// format price based on theme money format
const shopifyPriceFormat = price =>
  Shopify.formatMoney(price, window.theme.moneyFormat);

const LOCALE_CURRENCY_PREFIX_MAPPING = {
  CAD: 'C',
  AUD: 'A',
  HKD: 'HK',
  SGD: 'S',
  NZD: 'NZ',
  JPY: 'JP ',
  CNY: 'CN '
};

// special formatting for non-USD dollar-sign based currencies
const localePriceFormat = (price, isoCode) =>
  LOCALE_CURRENCY_PREFIX_MAPPING.hasOwnProperty(isoCode)
    ? `${LOCALE_CURRENCY_PREFIX_MAPPING[isoCode]}${shopifyPriceFormat(price)}`
    : shopifyPriceFormat(price);

// ejs-based mini-cart template
const miniCartTemplate = `
<% if (cart.item_count > 0) { %>
    <div class="row side-products">
      <% var count = 1 %>
      <% cart.items.map(item => { %>
        <div class="mini_cart_loop item_cart_<%= item.id %>">

          <div class="col-md-4 col-sm-4 col-xs-4">

            <% if (hasProperties(item)) { getCustomImagePath(item); %>
              <img class="cart__image" src="<%= getCustomImagePath(item); %>" alt="<%= item.title %>" data-item-url="<%= item.url %>">
            <% } else { %>
              <img class="cart__image" src="<%= item.image %>" alt="<%= item.title %>" data-item-url="<%= item.url %>">
            <% } %>

          </div>

          <div class="col-md-8 col-sm-8 col-xs-8">
            <div class="ajaxcart__product-name--wrapper">
              <a href="<%= item.url %>" class="ajaxcart__product-name">
                <%= item.product_title %>
                <% if (item.quantity > 1) { %>
                <span class="medium-up--hide"><span
                    class="visually-hidden"><%= cartTranslations.cart.label.quantity %></span>(x<%= item.quantity %>)</span>
                <% } %>
              </a>
              <span class="ajaxcart__product-meta">
                <% item.variant_options.map(option => { %>
                  <%= replaceEUAndCNCharacters(option) %>
                <% }); %>
              </span>
              <span class="ajaxcart__product-meta" style="font-style: italic;">
                <%= createFormattedLineItemPropertiesText(item) %>
              </span>
            </div>

            <div class="grid--full display-table">
              <div class="grid__item display-table-cell one-half">
                <div class="ajaxcart__qty">
                  <div class="cart__qty">
                    <span onClick="adjustCartLineItemQuantity(<%= item.id %>, <%= item.quantity - 1 %>)" type='button' value='-' class='qtyminus qtyminus<%= item.id %>' field='updates_<%= item.id %>'
                      style="color: #232323; cursor: pointer; opacity:1;">-</span>
                    <input disabled class="quantity quantity<%= item.id %>" type="number" name="updates[]"
                        id="updates_<%= item.id %>" value="<%= item.quantity %>" min="0" pattern="[0-9]*"
                        style="color: #232323; opacity:1;">
                    <span onClick="adjustCartLineItemQuantity(<%= item.id %>, <%= item.quantity + 1 %>)" type='button' value='+' class='qtyplus qtyplus<%= item.id %>' field='updates_<%= item.id %>'
style="color: #232323; cursor: pointer; opacity:1;">+</span>
                  </div>
                </div>
              </div>
              <div class="grid__item display-table-cell one-half text-right">
                <span class="ajaxcart__price money<%= item.id %>">
                  <% if (item.original_price != item.final_price) { %>
                    <dl>
                      <dt>
                        <span class="visually-hidden"><%= cartTranslations.products.product.regularPrice %></span>
                      </dt>
                      <dd>
                        <s><%- localePriceFormat(item.original_price, cartTranslations.__meta.currency.isoCode) %></s>
                      </dd>
                      <dt>
                        <span class="visually-hidden"><%= cartTranslations.products.product.salePrice %></span>
                      </dt>
                      <dd>
                        <span class="order-discount"><%- Shopify.formatMoney(item.final_price, window.theme.moneyFormat) %></span>
                      </dd>
                    </dl>
                  <% } else { %>
                    <%- localePriceFormat(item.original_price, cartTranslations.__meta.currency.isoCode) %>
                  <% } %>
                </span>

                <% if (item.line_level_discount_allocations != '') { %>
                <ul class="order-discount order-discount--list order-discount--title order-discount--cart" aria-label="<%= cartTranslations.customer.order.discount %>">
                  <% item.line_level_discount_allocations.map(discount_allocation => { %>
                    <li class="order-discount__item">
                      <%= discount_allocation.discount_application.title %>
                      (-<%= discount_allocation.amount %>)
                    </li>
                  <% }) %>
                </ul>
                <% } %>

              </div>
            </div>

          </div>
        </div>
        <% count++; %>
      <% }); %>
    </div>

  <div class="ajaxcart__footer ajaxcart__footer--fixed">
    <div class="grid--full">
      <div class="grid__item two-thirds">
        <p class="ajaxcart__subtotal"><%= cartTranslations.cart.general.subtotal %></p>
      </div>
      <div class="grid__item one-third text-right">
        <p class="ajaxcart__subtotal">
          <span class="money subtotal_price">
            <%- localePriceFormat(cart.total_price, cartTranslations.__meta.currency.isoCode) %></span>
        </p>
      </div>
    </div>

    <div class="cart__shipping rte">
      <%- cartTranslations.cart.general.taxesShippingCheckoutMessage %>
    </div>
  
    <div class="cart__submit-controls">
      <span id="cart_update" onClick="window.location.href = '/checkout';"
        class="dark-btn btn--small-wide cart__submit cart__submit-control">
        <%= cartTranslations.cart.general.checkout %>
      </span>
    </div>
  </div>

<% } else { %>
  <p class="min_cart_empty_text">Your cart is currently empty.</p>
<% } %>
`;

const replaceEUAndCNCharacters = (str) => str.replace(/- ([CN]|[EU])\w+/, '');
 
const createFormattedLineItemPropertiesText = (item) => 
  Object.entries(item.properties).map(([k, v]) =>
    Object.entries(v).map(entry =>
      entry.map(itm =>
        _.startCase(itm)
      ).join(': ')
    )
  ).join(', ');

const formatImageItem = (item) => Array.isArray(item) && item[0].includes('suede') ? item[0].replace('-','') : item;

const createFormattedLineItemImageString = (item) => Object.keys(item.properties).map(prop => formatImageItem(Object.values(item.properties[prop]))).join('-');


// TODO : refactor this
const CUSTOM_IMAGE_BASE_URL = 'https://cdn.shopify.com/s/files/1/0340/1305/2987/files';
const CUSTOM_IMAGE_FILENAME_PREFIX = 'gm-milcx';
const CUSTOM_IMAGE_FILENAME_SUFFIX = 'side';
const CUSTOM_IMAGE_EXTENSION = '.png';

const getCustomImageFilename = (item) => 
  [ CUSTOM_IMAGE_FILENAME_PREFIX,
    createFormattedLineItemImageString(item),
    CUSTOM_IMAGE_FILENAME_SUFFIX,
  ]
  .join('-')
  .concat(CUSTOM_IMAGE_EXTENSION);

const getCustomImagePath = (item) => [CUSTOM_IMAGE_BASE_URL, getCustomImageFilename(item)].join('/');

const hasProperties = (item) => !_.isEmpty(item.properties);

// render ejs-based mini-cart template
function renderMiniCart(params) {
  try {
    // build mini-cart from ejs template
    const miniCart = ejs.render(miniCartTemplate, {...params, replaceEUAndCNCharacters, createFormattedLineItemPropertiesText, hasProperties, getCustomImagePath});
    
    // grab dom container for mini-cart
    const domTarget = $('#side-cart-contents');

    // inject mini-cart to dom-container
    domTarget.html(miniCart);
    
    // stop propagation on click elements so we don't trigger multiple fires
    $(domTarget)
      .find('span')
      .on('click', function(evt) {
        evt.stopPropagation();
      });
  } catch (e) {
    throw new Error(`Error in rendering mini cart : ${e}`);
  }
}
